export default "<div> <button ng-repeat=\"button in vm.options.buttons\" class=btn-array ng-class=\"{'default':button.selected,'secondary':!button.selected}\" ng-disabled=button.selected ng-click=vm.select(button)>{{button.name}}</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/dashboard/btnarray.directive.tpl.html
// module id = 536
// module chunks = 0